import ClipLoader from 'react-spinners/ClipLoader';

export interface IClipSpinnerProps {
  size?: number;
  color?: string;
}
export function ClipSpinner({ size, color }: IClipSpinnerProps) {
  return (
    <div className="flex justify-center items-center">
      <ClipLoader
        color={color || 'white'}
        loading={true}
        size={size || 20}
        aria-label="Loading Spinner"
        data-testid="loader"
      />
    </div>
  );
}
